import { __assign } from "tslib";
import { getDeviceInfo, getIsMobileOrTablet, } from '@office-start/device-detection-utility';
import { ActionContextMenuItemIcon, ContentActionGroup, } from '@office-start/document-types';
import { OfficeWorkload, } from '@office-start/officehome-types';
import { createActionExecutor } from './../actionExecutor';
import { getInMemoryActionManager } from './../actionManager';
export var getActionsSystemConfig = function (_a) {
    var actionsGates = _a.actionsGates, capabilities = _a.capabilities, componentContext = _a.componentContext, userEntitlements = _a.userEntitlements, userDriveId = _a.userDriveId;
    return {
        calendarEnabled: userEntitlements.HasCalendar,
        companyDisplayName: userEntitlements.CompanyDisplayName || '',
        deviceInfo: {
            isPlatformMobileOrTablet: getIsMobileOrTablet(),
            isHwa: componentContext.workload === OfficeWorkload.Hwa,
            isEmbed: componentContext.workload === OfficeWorkload.Embed,
            browserType: getDeviceInfo().browser.browserType,
        },
        exchangeEnabled: userEntitlements.HasExchange,
        featureGates: actionsGates,
        oneDriveEnabled: userEntitlements.HasOneDrive,
        userDriveId: userDriveId,
        userType: capabilities.isConsumerUser ? 'Consumer' : 'Enterprise',
        isGovernment: userEntitlements.IsGovernment,
    };
};
export var getActionsGates = function (featureGates) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    return {
        actionActivityEnabled: ((_a = featureGates.actionActivityGates) === null || _a === void 0 ? void 0 : _a.actionActivityEnabled) || false,
        addToDoEnabled: ((_b = featureGates === null || featureGates === void 0 ? void 0 : featureGates.addToDoGates) === null || _b === void 0 ? void 0 : _b.addToDoEnabled) || false,
        contentActionsEnabled: ((_c = featureGates === null || featureGates === void 0 ? void 0 : featureGates.contentActionsGates) === null || _c === void 0 ? void 0 : _c.contentActionsEnabled) || false,
        contextMenu20Enabled: ((_d = featureGates === null || featureGates === void 0 ? void 0 : featureGates.contextMenu20Gates) === null || _d === void 0 ? void 0 : _d.contextMenu20Enabled) || false,
        compliantShareApiEnabled: ((_e = featureGates === null || featureGates === void 0 ? void 0 : featureGates.compliantShareApiGates) === null || _e === void 0 ? void 0 : _e.compliantShareApiEnabled) ||
            false,
        convertToPdfEnabled: ((_f = featureGates === null || featureGates === void 0 ? void 0 : featureGates.convertToPdfGates) === null || _f === void 0 ? void 0 : _f.convertToPdfEnabled) || false,
        createSharingLinkApiEnabled: ((_g = featureGates === null || featureGates === void 0 ? void 0 : featureGates.createSharingLinkApiGates) === null || _g === void 0 ? void 0 : _g.createSharingLinkApiEnabled) || false,
        downloadActionEnabled: ((_h = featureGates === null || featureGates === void 0 ? void 0 : featureGates.downloadActionGates) === null || _h === void 0 ? void 0 : _h.downloadActionEnabled) || false,
        deleteActionEnabled: ((_j = featureGates === null || featureGates === void 0 ? void 0 : featureGates.deleteActionGates) === null || _j === void 0 ? void 0 : _j.deleteActionEnabled) || false,
        linksEnabled: ((_k = featureGates === null || featureGates === void 0 ? void 0 : featureGates.edgeworthConfigGates) === null || _k === void 0 ? void 0 : _k.edgeworthConfigLinksEnabled) ||
            false,
        mosContentActionEnabled: ((_l = featureGates === null || featureGates === void 0 ? void 0 : featureGates.mosContentActionGates) === null || _l === void 0 ? void 0 : _l.mosContentActionEnabled) ||
            false,
        graphApiForV2ConsumerEnabled: ((_m = featureGates.graphApiForV2ConsumerGates) === null || _m === void 0 ? void 0 : _m.graphApiForV2ConsumerEnabled) || false,
        odspCopyLinkEnabled: ((_o = featureGates.odspCopyLinkGates) === null || _o === void 0 ? void 0 : _o.odspCopyLinkEnabled) || false,
        odspShareLinkEnabled: ((_p = featureGates.odspShareLinkGates) === null || _p === void 0 ? void 0 : _p.odspShareLinkEnabled) || false,
        scheduleEnabled: ((_q = featureGates === null || featureGates === void 0 ? void 0 : featureGates.scheduleGates) === null || _q === void 0 ? void 0 : _q.scheduleEnabled) || false,
        shareToTeamsEnabled: ((_r = featureGates === null || featureGates === void 0 ? void 0 : featureGates.shareToTeamsGates) === null || _r === void 0 ? void 0 : _r.shareToTeamsEnabled) || false,
        shareTokenClaimsEnabled: ((_s = featureGates === null || featureGates === void 0 ? void 0 : featureGates.shareTokenClaimsGates) === null || _s === void 0 ? void 0 : _s.shareTokenClaimsEnabled) ||
            false,
        testAppActionEnabled: ((_t = featureGates === null || featureGates === void 0 ? void 0 : featureGates.testAppActionGates) === null || _t === void 0 ? void 0 : _t.testAppActionEnabled) || false,
    };
};
export var getActionControls = function (actionsInContextDialogResources, documentActionsMenuResources, documentActionsToastResources, systemConfig, options) {
    var actionManager = getInMemoryActionManager(actionsInContextDialogResources, documentActionsMenuResources, documentActionsToastResources, systemConfig);
    if (!actionManager) {
        return undefined;
    }
    // Create action executor
    var actionExecutor = createActionExecutor(__assign(__assign({}, options), { actionManager: actionManager }));
    if (!actionExecutor) {
        return undefined;
    }
    return { actionManager: actionManager, actionExecutor: actionExecutor };
};
export var getActionsGroupInfo = function (locStrings) {
    var _a;
    return _a = {},
        _a[ContentActionGroup.AddTo] = {
            ariaLabel: locStrings.documentActionsMenuResources.addToMenuTitle,
            icon: {
                type: ActionContextMenuItemIcon.ActionContextMenuIcon,
                iconName: 'AddIcon',
            },
            id: ContentActionGroup.AddTo,
            title: locStrings.documentActionsMenuResources.addToMenuTitle,
        },
        _a[ContentActionGroup.Share] = {
            ariaLabel: locStrings.documentActionsMenuResources.shareActionTitle,
            icon: {
                type: ActionContextMenuItemIcon.ActionContextMenuIcon,
                iconName: 'ShareIcon',
            },
            id: ContentActionGroup.Share,
            title: locStrings.documentActionsMenuResources.shareActionTitle,
        },
        _a;
};
//# sourceMappingURL=systemActionHelper.js.map